export function setCookie(c_name, value, expiredays) {
    var exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    // document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString() + ';path=\')
    // document.cookie =`${c_name}=${escape(value)},expires=${exdate.toGMTString()},path=\`
    // var expdate = new Date();   //初始化时间
    // expdate.setTime(expdate.getTime() + 30 * 60 * 1000);   //时间
    document.cookie = c_name+"="+value+";expires="+exdate.toGMTString()+";domain=https://www.zhipin.com"+';path:/';
}


export function getCookie(c_name) {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=")
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1
            let c_end = document.cookie.indexOf(";", c_start)
            if (c_end == -1) c_end = document.cookie.length
            return unescape(document.cookie.substring(c_start, c_end))
        }
    }
    return ""
}

export function delCookie(c_name) {
    setCookie(c_name, "", -1)
}


// WEBPACK FOOTER //
// ./src/assets/cookie.js